"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _emailIntegration = require("./emailIntegration.styles");

var IntegrationProtip = function IntegrationProtip(_ref) {
  var isDkimProvider = _ref.isDkimProvider;
  return /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: _emailIntegration.styles.text
  }, isDkimProvider ? 'Without the integration enabled, each recipient will be asked to select free times and your team member will need to manually select & confirm availability for every meeting booking' : 'Connecting your account allows Alyce to send invites and book meetings on your behalf. It’s also the best way for your invites to end up in your recipients inbox as opposed to their spam folders.');
};

var _default = IntegrationProtip;
exports.default = _default;